/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

  /******
   * Text Slider
   ******/

  var slideSpeed = 5000;
  // Try to get the slider speed data, if not exist, use 5 sec as default.
  try {
    slideSpeed = document.getElementById('text-slider__list').dataset.speed * 1000;
  } catch(err) {
    var errorMsg = err.message;
  }

  jQuery('.text-slider__list').slick({
    autoplay: true,
    autoplaySpeed: slideSpeed,
    dots: false,
    slidesToShow: 1,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img class='svg' src='/wp-content/themes/DailyPress/assets/images/back-arrow-circular-symbol.svg'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img class='svg' src='/wp-content/themes/DailyPress/assets/images/right-arrow-circular-button.svg'></button>",
  });

  /*
   * Replace all SVG images with inline SVG
   */
  jQuery('img.svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');
      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') { $svg = $svg.attr('id', imgID); }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') { $svg = $svg.attr('class', imgClass+' replaced-svg'); }
      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');
      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });
});

/******
 * Hero Slider
 ******/

if(jQuery('.hero-slider .hero-slider__container .hero-slider__container--background').length > 1) {
  jQuery('.hero-slider__container').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    pauseOnHover: true,
    prevArrow: false,
    nextArrow: false
  });
}

/********
 * Debounce function
 *
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The function will be called after it stops being called for N milliseconds.
 * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 *
 * Reference: https://davidwalsh.name/javascript-debounce-function
 ********/

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/******
 * Mobile And Desktop Menu: Events and Settings
 ******/

 var menuState = ""; //initialize menu state
 var navigationBreakpoint = 1440; //nav menu breakpoint is 1440px (xxlarge in Foundation 6)
 var mobileDesktopMenuSwitch = debounce(function(){ //active the function every 250ms to improve website performance
   if(menuState !== "mobile" && window.innerWidth < navigationBreakpoint) {
     menuState = "mobile";
     jQuery('.hamburger-icon').on('click', function(e){
       e.preventDefault();
       jQuery(this).toggleClass('active');
       jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
       //jQuery('.mobile-menu').removeClass('second-level-open');
       //jQuery('.menu-item-has-children').removeClass('open');
       jQuery('html').toggleClass('no-scroll');
     });

    //  jQuery('.menu-item-has-children > a').click(function(e){
    //   e.preventDefault();
    //   jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
    //   jQuery(this).parent().toggleClass('open');
    //  });

     /*jQuery('.menu-item-has-children > a').one('click', function(){
       jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
     });*/

     /* allow the link(has children) only expand once, then clickable */
     jQuery('.menu-item-has-children > a').one('click', function(e){
      e.preventDefault();
      jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
      jQuery(this).parent().toggleClass('open');
    });

     jQuery('.mobile-menu .back-to-main').click(function(){
       //jQuery('.mobile-menu').removeClass('second-level-open');
       //jQuery('.menu-item-has-children').removeClass('open');
     });

   } else if(window.innerWidth >= navigationBreakpoint) {
      menuState = "desktop";
      jQuery('.hamburger-icon').off('click');
      jQuery('.menu-item-has-chilcren > a').off('click');
      jQuery('.second-level-menu .back').off('click');
   }
 }, 250);

 mobileDesktopMenuSwitch();
 window.addEventListener('resize', mobileDesktopMenuSwitch)


 /*****
 * Initialize Lightbox Gallery
 *****/
function initLightbox(parentClass) {
  if(typeof parentClass === 'undefined' || !parentClass) return; //early return if parentClass is undefined

  jQuery(parentClass+'__image, '+parentClass+'__more').on('click', function(){
    var index = jQuery(this).data('index');
    var lightbox = jQuery(this).parents(parentClass).find(parentClass+'__lightbox');
    lightbox.addClass('active');
    setTimeout(function() { //strangely needs timeout to works
      lightbox.find('.lightbox').slick('slickGoTo', index, true);
    }, 10)
  });

  jQuery(parentClass+'__lightbox--close').on('click', function(){
    jQuery(this).parent().removeClass('active');
  });

  //Main Slider
  jQuery(parentClass+'__lightbox .lightbox').slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    lazyLoad: 'ondemand',
    arrows: true,
    prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox-navigation',
  });

  //Navigation Slider
  jQuery(parentClass+'__lightbox .lightbox-navigation').slick({
    slidesToShow: 4,
    infinite: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,
    swipeToSlide: true,
    prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
    nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
    asNavFor: parentClass+'__lightbox .lightbox',
    responsive: [
      {
        breakpoint: 680,
        settings: {
            slidesToShow: 3,
        }
      }
    ]
  });
}
initLightbox('.dining-info');
initLightbox('.gallery');

/********
 * Initialise Gallery Slider for Gallery snippet
 ********/
jQuery('.gallery-slider__lightbox .lightbox').slick({
  slidesToShow: 1,
  infinite: false,
  dots: false,
  lazyLoad: 'ondemand',
});
